(function () {
  if (window.PADSetSavingsMeter) {
    window.PADSetSavingsMeter.initAll();
    return;
  }

  var selectors = {
    root: "[data-set-savings-meter]",
    card: "[data-meter-card]",
    tab: "[data-meter-tab]",
    tabPanel: "[data-meter-tab-panel]",
    select: "[data-meter-select]",
    selectLabel: "[data-meter-select-label]",
    panel: "[data-meter-panel]",
    stateCopy: "[data-meter-state-copy]",
    progress: "[data-meter-progress]",
    progressFill: "[data-meter-progress-fill]",
    progressText: "[data-meter-progress-text]",
    setValue: "[data-meter-set-value]",
    todayPrice: "[data-meter-today-price]",
    savings: "[data-meter-savings]",
    selectedList: "[data-meter-selected-list]",
    checkout: "[data-meter-checkout]",
    checkoutList: "[data-meter-checkout-list]",
    checkoutAction: "[data-meter-checkout-action]",
    cta: "[data-meter-cta]",
    productLink: "[data-meter-product-link]"
  };

  function toNumber(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : fallback;
  }

  function toPlainText(value) {
    var wrapper = document.createElement("span");
    wrapper.innerHTML = String(value || "");
    return wrapper.textContent || wrapper.innerText || "";
  }

  function formatMoney(cents) {
    var safeCents = Math.max(0, toNumber(cents, 0));

    if (
      window.theme &&
      window.theme.Currency &&
      typeof window.theme.Currency.formatMoney === "function"
    ) {
      return toPlainText(
        window.theme.Currency.formatMoney(
          safeCents,
          window.theme.settings && window.theme.settings.moneyFormat
        )
      );
    }

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: safeCents % 100 === 0 ? 0 : 2
    }).format(safeCents / 100);
  }

  function getStateCopy(root, selectedCount, targetCount) {
    if (selectedCount >= targetCount) {
      return root.dataset.completeCopy;
    }

    if (selectedCount === 2) {
      return root.dataset.twoCopy;
    }

    if (selectedCount === 1) {
      return root.dataset.oneCopy;
    }

    return root.dataset.emptyCopy;
  }

  function activateTab(root, tabKey, focusTab) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll(selectors.tab));
    var panels = Array.prototype.slice.call(root.querySelectorAll(selectors.tabPanel));
    var activeTab = tabs.find(function (tab) {
      return tab.dataset.tab === tabKey;
    }) || tabs[0];

    if (!activeTab) {
      panels.forEach(function (panel) {
        panel.classList.add("is-active");
        panel.hidden = false;
      });
      return;
    }

    var activeKey = activeTab.dataset.tab;

    tabs.forEach(function (tab) {
      var isActive = tab.dataset.tab === activeKey;
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
      tab.classList.toggle("is-active", isActive);
    });

    panels.forEach(function (panel) {
      var isActive = panel.dataset.tab === activeKey;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });

    root.dataset.activeTab = activeKey;

    if (focusTab) {
      activeTab.focus();
    }
  }

  function getNextTab(tabs, currentIndex, direction) {
    if (!tabs.length) {
      return null;
    }

    var nextIndex = currentIndex + direction;

    if (nextIndex < 0) {
      nextIndex = tabs.length - 1;
    }

    if (nextIndex >= tabs.length) {
      nextIndex = 0;
    }

    return tabs[nextIndex];
  }

  function buildSelectedItem(button) {
    return {
      button: button,
      card: button.closest(selectors.card),
      title: button.dataset.title || "Selected style",
      link: button.dataset.link || "#",
      priceCents: Math.max(0, toNumber(button.dataset.priceCents, 0)),
      valueCents: Math.max(0, toNumber(button.dataset.valueCents, 0)),
      cartBehavior: button.dataset.cartBehavior || "configure",
      cartActionLabel: button.dataset.cartActionLabel || "",
      productId: button.dataset.productId || "",
      variantId: button.dataset.variantId || "",
      variantAvailable: button.dataset.variantAvailable === "true",
      hasOnlyDefaultVariant: button.dataset.productHasOnlyDefaultVariant === "true"
    };
  }

  function computeTotals(selected, targetCount, paidItemCount) {
    var setValue = selected.reduce(function (total, item) {
      return total + item.valueCents;
    }, 0);
    var todayPrice = selected.reduce(function (total, item) {
      return total + item.priceCents;
    }, 0);

    if (selected.length >= targetCount) {
      todayPrice = selected
        .map(function (item) {
          return item.priceCents;
        })
        .sort(function (a, b) {
          return b - a;
        })
        .slice(0, paidItemCount)
        .reduce(function (total, price) {
          return total + price;
        }, 0);
    }

    return {
      setValue: setValue,
      todayPrice: todayPrice,
      savings: Math.max(0, setValue - todayPrice)
    };
  }

  function setButtonState(button, isSelected) {
    var label = button.querySelector(selectors.selectLabel);
    var title = button.dataset.title || "this style";

    button.setAttribute("aria-pressed", isSelected ? "true" : "false");
    button.setAttribute(
      "aria-label",
      (isSelected ? "Deselect " : "Select ") + title
    );

    if (label) {
      label.textContent = isSelected ? "Selected" : "Select";
    }

    var card = button.closest(selectors.card);
    if (card) {
      card.dataset.selected = isSelected ? "true" : "false";
    }
  }

  function renderSelectedList(list, selected, targetCount) {
    list.innerHTML = "";

    if (!selected.length) {
      var emptyItem = document.createElement("li");
      emptyItem.textContent =
        "Choose up to " + targetCount + " eligible pieces to preview the set.";
      list.appendChild(emptyItem);
      return;
    }

    selected.forEach(function (item, index) {
      var listItem = document.createElement("li");
      var link = document.createElement("a");

      link.href = item.link;
      link.target = "_blank";
      link.rel = "noopener";
      link.textContent = index + 1 + ". " + item.title;
      link.dataset.meterProductLink = "true";
      link.dataset.meterProductSource = "selected-list";
      link.dataset.title = item.title;
      listItem.appendChild(link);
      list.appendChild(listItem);
    });
  }

  function getCheckoutActionLabel(item) {
    if (item.cartActionLabel) {
      return item.cartActionLabel;
    }

    if (item.cartBehavior === "quick_add") {
      return "Add to Cart";
    }

    if (item.cartBehavior === "choose_variant") {
      return "Choose Size";
    }

    return "Customize & Add";
  }

  function getCheckoutMeta(item) {
    if (item.cartBehavior === "quick_add" && item.variantAvailable && item.variantId) {
      return "Ready to add from this page.";
    }

    if (item.cartBehavior === "quick_add") {
      return "Open the style page to confirm availability.";
    }

    if (item.cartBehavior === "choose_variant") {
      return "Choose the size and options on the product page.";
    }

    return "Finish customization on the product page.";
  }

  function isQuickAddReady(item) {
    return item.cartBehavior === "quick_add" && item.variantId && item.variantAvailable;
  }

  function renderCheckoutList(checkout, list, selected, isComplete) {
    if (!checkout || !list) {
      return;
    }

    checkout.hidden = !isComplete;
    list.innerHTML = "";

    if (!isComplete) {
      return;
    }

    selected.forEach(function (item, index) {
      var listItem = document.createElement("li");
      var copy = document.createElement("div");
      var title = document.createElement("p");
      var meta = document.createElement("p");
      var action;

      listItem.className = "sale-set-savings-meter__checkout-item";
      copy.className = "sale-set-savings-meter__checkout-copy";
      title.className = "sale-set-savings-meter__checkout-title";
      meta.className = "sale-set-savings-meter__checkout-meta";
      title.textContent = index + 1 + ". " + item.title;
      meta.textContent = getCheckoutMeta(item);

      copy.appendChild(title);
      copy.appendChild(meta);
      listItem.appendChild(copy);

      if (isQuickAddReady(item)) {
        action = document.createElement("button");
        action.type = "button";
        action.dataset.meterCheckoutAction = "quick-add";
        action.dataset.index = String(index);
      } else {
        action = document.createElement("a");
        action.href = item.link;
        action.target = "_blank";
        action.rel = "noopener";
        action.dataset.meterProductLink = "true";
        action.dataset.meterProductSource = "checkout-step";
        action.dataset.title = item.title;
      }

      action.className = "sale-set-savings-meter__checkout-action";
      action.textContent =
        item.cartBehavior === "quick_add" && !isQuickAddReady(item)
          ? "Open Style"
          : getCheckoutActionLabel(item);
      listItem.appendChild(action);
      list.appendChild(listItem);
    });
  }

  function shouldOpenNewTab(href) {
    return Boolean(href && href !== "#" && href.charAt(0) !== "#");
  }

  function getPrimaryCtaState(root, cta, checkout, selected, isComplete) {
    if (!isComplete) {
      var defaultHref = root.dataset.defaultCtaLink || "#";
      return {
        label: root.dataset.defaultCtaLabel,
        href: defaultHref,
        action: "default",
        newTab: shouldOpenNewTab(defaultHref)
      };
    }

    if (selected.length && selected.every(isQuickAddReady)) {
      return {
        label: root.dataset.quickAddReadyLabel || "Add Set to Cart",
        href: root.dataset.cartUrl || root.dataset.completeCtaLink || "#",
        action: "quick-add-set",
        newTab: false
      };
    }

    return {
      label: root.dataset.reviewCtaLabel || root.dataset.completeCtaLabel || "Review My Set",
      href: checkout && checkout.id ? "#" + checkout.id : root.dataset.completeCtaLink || "#",
      action: "review-set",
      newTab: false
    };
  }

  function setBusy(element, isBusy, label) {
    if (!element) {
      return;
    }

    if (isBusy) {
      element.dataset.originalLabel = element.textContent;
      element.textContent = label || element.textContent;
      element.setAttribute("aria-busy", "true");
      if (element.tagName === "BUTTON") {
        element.disabled = true;
      }
      return;
    }

    element.textContent = element.dataset.originalLabel || element.textContent;
    element.removeAttribute("aria-busy");
    if (element.tagName === "BUTTON") {
      element.disabled = false;
    }
  }

  function emitQuickAdd(root, eventName, items) {
    document.dispatchEvent(
      new CustomEvent(eventName, {
        detail: {
          section: root,
          items: items.map(function (item) {
            return {
              title: item.title,
              productId: item.productId,
              variantId: item.variantId
            };
          })
        }
      })
    );
  }

  function quickAddItems(root, items) {
    var readyItems = items.filter(isQuickAddReady);
    var addUrl = root.dataset.cartAddUrl || "/cart/add.js";

    if (!readyItems.length || typeof window.fetch !== "function") {
      return Promise.reject(new Error("No quick-add-ready items were selected."));
    }

    emitQuickAdd(root, "pad:set-savings-meter:quick-add-start", readyItems);

    return window.fetch(addUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: readyItems.map(function (item) {
          return {
            id: Number(item.variantId),
            quantity: 1,
            properties: {
              "_Bundle Builder": "Build Your Set Savings Meter"
            }
          };
        })
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Quick add failed.");
      }

      emitQuickAdd(root, "pad:set-savings-meter:quick-add-success", readyItems);
      return response.json();
    });
  }

  function emitUpdate(root, selected, totals, complete) {
    var eventName = complete
      ? "pad:set-savings-meter:complete"
      : "pad:set-savings-meter:update";

    document.dispatchEvent(
      new CustomEvent(eventName, {
        detail: {
          section: root,
          selectedCount: selected.length,
          selectedTitles: selected.map(function (item) {
            return item.title;
          }),
          setValueCents: totals.setValue,
          todayPriceCents: totals.todayPrice,
          savingsCents: totals.savings
        }
      })
    );
  }

  function emitClick(root, eventName, clickedElement, selected, totals, targetCount) {
    document.dispatchEvent(
      new CustomEvent(eventName, {
        detail: {
          section: root,
          href: clickedElement.href || clickedElement.getAttribute("href") || "",
          label: (clickedElement.textContent || "").trim(),
          source: clickedElement.dataset.meterProductSource || "",
          title: clickedElement.dataset.title || "",
          selectedCount: selected.length,
          selectedTitles: selected.map(function (item) {
            return item.title;
          }),
          setValueCents: totals.setValue,
          todayPriceCents: totals.todayPrice,
          savingsCents: totals.savings,
          complete: selected.length >= targetCount
        }
      })
    );
  }

  function init(root) {
    if (!root || root.dataset.meterInitialized === "true") {
      return;
    }

    root.dataset.meterInitialized = "true";

    var tabs = Array.prototype.slice.call(root.querySelectorAll(selectors.tab));
    var buttons = Array.prototype.slice.call(root.querySelectorAll(selectors.select));
    var panel = root.querySelector(selectors.panel);
    var stateCopy = root.querySelector(selectors.stateCopy);
    var progress = root.querySelector(selectors.progress);
    var progressFill = root.querySelector(selectors.progressFill);
    var progressText = root.querySelector(selectors.progressText);
    var setValue = root.querySelector(selectors.setValue);
    var todayPrice = root.querySelector(selectors.todayPrice);
    var savings = root.querySelector(selectors.savings);
    var selectedList = root.querySelector(selectors.selectedList);
    var checkout = root.querySelector(selectors.checkout);
    var checkoutList = root.querySelector(selectors.checkoutList);
    var cta = root.querySelector(selectors.cta);
    var targetCount = Math.max(3, toNumber(root.dataset.targetCount, 3));
    var paidItemCount = Math.max(1, toNumber(root.dataset.paidItemCount, 1));
    var selected = [];
    var hasCompleted = false;

    paidItemCount = Math.min(paidItemCount, targetCount);

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activateTab(root, tab.dataset.tab, false);
      });

      tab.addEventListener("keydown", function (event) {
        var currentIndex = tabs.indexOf(tab);
        var nextTab = null;

        if (event.key === "ArrowRight") {
          nextTab = getNextTab(tabs, currentIndex, 1);
        } else if (event.key === "ArrowLeft") {
          nextTab = getNextTab(tabs, currentIndex, -1);
        } else if (event.key === "Home") {
          nextTab = tabs[0];
        } else if (event.key === "End") {
          nextTab = tabs[tabs.length - 1];
        }

        if (nextTab) {
          event.preventDefault();
          activateTab(root, nextTab.dataset.tab, true);
        }
      });
    });

    root.classList.add("is-tabs-ready");
    activateTab(root, root.dataset.activeTab || root.dataset.defaultTab || (tabs[0] && tabs[0].dataset.tab), false);

    function update() {
      var totals = computeTotals(selected, targetCount, paidItemCount);
      var isComplete = selected.length >= targetCount;
      var progressPercent = Math.min(100, (selected.length / targetCount) * 100);

      if (panel) {
        panel.classList.add("is-updating");
        window.setTimeout(function () {
          panel.classList.remove("is-updating");
        }, 170);
      }

      if (stateCopy) {
        stateCopy.textContent = getStateCopy(root, selected.length, targetCount);
      }

      if (progress) {
        progress.setAttribute("aria-valuenow", String(Math.min(selected.length, targetCount)));
      }

      if (progressFill) {
        progressFill.style.width = progressPercent + "%";
      }

      if (progressText) {
        progressText.textContent =
          Math.min(selected.length, targetCount) +
          " of " +
          targetCount +
          " selected";
      }

      if (setValue) {
        setValue.textContent = formatMoney(totals.setValue);
      }

      if (todayPrice) {
        todayPrice.textContent = formatMoney(totals.todayPrice);
      }

      if (savings) {
        savings.textContent = formatMoney(totals.savings);
      }

      if (selectedList) {
        renderSelectedList(selectedList, selected, targetCount);
      }

      renderCheckoutList(checkout, checkoutList, selected, isComplete);

      if (cta) {
        var ctaState = getPrimaryCtaState(root, cta, checkout, selected, isComplete);
        cta.textContent = ctaState.label || root.dataset.defaultCtaLabel || "See Eligible Styles";
        cta.href = ctaState.href || "#";
        cta.dataset.meterCtaAction = ctaState.action;
        cta.dataset.meterComplete = isComplete ? "true" : "false";

        if (ctaState.newTab) {
          cta.target = "_blank";
          cta.rel = "noopener";
        } else {
          cta.removeAttribute("target");
          cta.removeAttribute("rel");
        }
      }

      if (isComplete && !hasCompleted) {
        emitUpdate(root, selected, totals, true);
      } else {
        emitUpdate(root, selected, totals, false);
      }

      hasCompleted = isComplete;
    }

    function toggle(button) {
      var existingIndex = selected.findIndex(function (item) {
        return item.button === button;
      });

      if (existingIndex > -1) {
        selected.splice(existingIndex, 1);
        setButtonState(button, false);
        update();
        return;
      }

      if (selected.length >= targetCount) {
        var removed = selected.shift();
        if (removed && removed.button) {
          setButtonState(removed.button, false);
        }
      }

      selected.push(buildSelectedItem(button));
      setButtonState(button, true);
      update();
    }

    buttons.forEach(function (button) {
      setButtonState(button, false);
      button.addEventListener("click", function () {
        toggle(button);
      });
    });

    root.addEventListener("click", function (event) {
      var clickedTarget = event.target;

      if (!clickedTarget || typeof clickedTarget.closest !== "function") {
        return;
      }

      var ctaClick = clickedTarget.closest(selectors.cta);
      var checkoutAction = clickedTarget.closest(selectors.checkoutAction);
      var productClick = clickedTarget.closest(selectors.productLink);

      if (!ctaClick && !checkoutAction && !productClick) {
        return;
      }

      var totals = computeTotals(selected, targetCount, paidItemCount);

      if (ctaClick) {
        emitClick(
          root,
          "pad:set-savings-meter:cta-click",
          ctaClick,
          selected,
          totals,
          targetCount
        );

        if (ctaClick.dataset.meterCtaAction === "review-set" && checkout) {
          event.preventDefault();
          var scrollBehavior =
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
              ? "auto"
              : "smooth";
          checkout.hidden = false;
          checkout.focus({ preventScroll: true });
          checkout.scrollIntoView({ behavior: scrollBehavior, block: "nearest" });
          return;
        }

        if (ctaClick.dataset.meterCtaAction === "quick-add-set") {
          event.preventDefault();
          setBusy(ctaClick, true, "Adding");
          quickAddItems(root, selected)
            .then(function () {
              ctaClick.textContent = root.dataset.quickAddSuccessLabel || "Added";
              window.location.href = root.dataset.cartUrl || "/cart";
            })
            .catch(function () {
              ctaClick.textContent = root.dataset.quickAddErrorText || "Open this style to finish adding it.";
              ctaClick.href = selected[0] ? selected[0].link : root.dataset.completeCtaLink || "#";
            })
            .finally(function () {
              ctaClick.removeAttribute("aria-busy");
            });
          return;
        }

        return;
      }

      if (checkoutAction && checkoutAction.dataset.meterCheckoutAction === "quick-add") {
        var actionIndex = toNumber(checkoutAction.dataset.index, -1);
        var actionItem = selected[actionIndex];

        if (!actionItem || !isQuickAddReady(actionItem)) {
          return;
        }

        event.preventDefault();
        setBusy(checkoutAction, true, "Adding");
        quickAddItems(root, [actionItem])
          .then(function () {
            checkoutAction.textContent = root.dataset.quickAddSuccessLabel || "Added";
            checkoutAction.disabled = true;
          })
          .catch(function () {
            checkoutAction.textContent = root.dataset.quickAddErrorText || "Open Style";
            window.setTimeout(function () {
              window.location.href = actionItem.link;
            }, 450);
          })
          .finally(function () {
            checkoutAction.removeAttribute("aria-busy");
          });
        return;
      }

      emitClick(
        root,
        "pad:set-savings-meter:product-link-click",
        productClick,
        selected,
        totals,
        targetCount
      );
    });

    update();
  }

  function initAll(scope) {
    var rootScope = scope || document;
    var roots = Array.prototype.slice.call(rootScope.querySelectorAll(selectors.root));

    if (rootScope.matches && rootScope.matches(selectors.root)) {
      roots.unshift(rootScope);
    }

    roots.forEach(init);
  }

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  window.PADSetSavingsMeter = {
    init: init,
    initAll: initAll
  };

  ready(function () {
    initAll();
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
